
var BadgeCollection = function(options){
    var oThis = this;

    oThis.defaults = {
        can_edit: false,
        portfolioid: null,
        collectionid: -1,
        filtercontrols: true,
        showOnEmpty: true,
        params: null
    }

    oThis.settings = $.extend( {}, oThis.defaults, options );
    oThis.noncurated = oThis.settings.collectionid == 0;
    oThis.fullset = oThis.settings.collectionid == -1;
    // oThis.bCanManage = mantl.userid == mantl.portfolio_user_user;
    oThis.bCanManage = false; //hardcoded to disable the button since we moved the functionality, but didn't remove from component yet
    oThis.Actions = Reflux.createActions(['fetchBadges', 'fetchSkills']);
    oThis.containerID;
    oThis.modalsID = "badgesCollectionModal";
    oThis.msgStack = new MessageStack();
    oThis.createStore();

    oThis.handleStack = function(){
        oThis.msgStack.Display(); //should we put these in a program builder container?
        oThis.msgStack.Clear();
    }

    //Program Designer
    oThis.BadgeCollection = createReactClass({
        mixins: [Reflux.connect(oThis.WorkStore, 'badges')],

        componentDidUpdate: function(){
            var $component = $(ReactDOM.findDOMNode(this));
            reactFixRowsCols($component);
            //$manager.find('.collapsible').collapsible();
        },

        getInitialState: function() {
            return {
                filters: {
                    open: false
                }
            }
        },

        handleToggleFilters: function(page) {
            this.setState({
                filters: {
                    open: !this.state.filters.open
                }
            });

        },

        render: function() {
            var oComponent = this;
            var emptyMsg = (oThis.settings.params != null) ? "No badges found that match your selected filters." : "No badges have been added.";

            if(this.state.badges){
                var badgesCols = (this.state.filters.open) ? 9 : 12;
                var badges = [];
                for(var i = 0; i < this.state.badges.items.length; i++){
                    var oItem = this.state.badges.items[i];
                    badges.push(<oThis.BadgeCollectionItem item={oItem} key={oItem.id} />);
                }

                if(badges.length == 0 && !oThis.settings.showOnEmpty){
                    return (null);
                } else {
                    return (
                        <div className="portfolio-content-badges">
                            {(function(){
                                if (oThis.settings.filtercontrols) {
                                return (<div>
                                    <a className="button--flat button--skinny sidebar-trigger" onClick={oComponent.handleToggleFilters} href="#filtersWork"><i className="icon-sliders"></i> Filters</a>
                                </div>);
                                }
                            })()}

                            <br />
                            <div data-row="row">
                                {(function(){
                                    if (oComponent.state.filters.open) {
                                    return (<oThis.BadgeCollectionFilters />);
                                    }
                                })()}

                                <div data-column={badgesCols} className="badge-grid">
                                    {(function(){
                                        if (badges.length > 0) {
                                            hideOnboarding();
                                            return badges;
                                    } else {
                                        return (<div className="alert alert--information text--xl"><h1 className="text--center h2">{emptyMsg}</h1> <img src={mantl.static_url + "assets/images/icon-collection.svg" } className="image--onboarding" alt="Collection Image" /></div>);
                                    }
                                    })()}
                                </div>
                            </div>
                        </div>
                    );
                }


            } else {
                return (
                    <div className="portfolio-content-badges">
                        <div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div>
                    </div>
                );
            }

        }
    });

    oThis.BadgeCollectionFilters = createReactClass({
        mixins: [Reflux.connect(oThis.SkillsStore, 'skills')],

        getInitialState: function() {
            return {
                datepickers: false
            }
        },

        componentDidMount: function() {
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
            reactFixRowsCols($component);
        },

        componentDidUpdate: function() {
            if(this.state.skills && !this.state.datepickers){
                pickerFrom = new Pikaday({
                    field: document.getElementById('date_from'),
                    defaultDate: new Date()
                });
                pickerTo = new Pikaday({
                    field: document.getElementById('date_to'),
                    defaultDate: new Date()
                });

                this.setState({
                    datepickers: true
                });
            }
        },

        handleFilter: function() {
            oThis.settings.params = $("#filters").serializeObject();
            oThis.Actions.fetchBadges();
        },

        handleClearFilter: function() {
            $("#filters input:checkbox").prop('checked',false);
            oThis.settings.params = null;
            oThis.Actions.fetchBadges();
        },

        render: function() {
            var oComponent = this;
            if(this.state.skills){

                var skills = [];
                for(var i = 0; i < this.state.skills.items.length; i++){
                    var oItem = this.state.skills.items[i];
                    if(oItem.badge_count > 0){
                        skills.push(<oThis.BadgeCollectionSkillCheckbox skill={oItem} key={oItem.id} />);
                    }
                }

                return (
                    <div id="filtersWork" data-column="3">
                        <form id="filters">
                            <ul className="collection">
                                <li className="collection-item">
                                    <h4>Date Added</h4>
                                    <div>
                                        <div className="input-group input--small">
                                            <label for="date_from" className="input-prefix input-prefix--date">From</label>
                                            <input type="text" id="date_from" name="date_from" className="datepicker" />
                                        </div>
                                        <div className="input-group input--small">
                                            <label for="date_to" className="input-prefix input-prefix--date">To</label>
                                            <input type="text"  id="date_to" name="date_to" className="datepicker" />
                                        </div>
                                    </div>
                                </li>
                                <li className="collection-item">
                                    <h4>Skills Reflected</h4>
                                    {skills}
                                </li>
                            </ul>
                        </form>

                        <button className="button--sm button--success" onClick={this.handleFilter}>Apply</button> <button className="button--sm" onClick={this.handleClearFilter}>Clear</button>
                    </div>
                );

            } else {
                return (
                    <div id="filtersWork" data-column="3"><div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div></div>
                )
            }



        }
    });


    oThis.BadgeCollectionSkillCheckbox = createReactClass({
        render: function() {
            var oComponent = this;
            return (
                <div>
                    <input type="checkbox" name="skill" value={this.props.skill.tag} id={'skill_' + this.props.skill.id} /><label htmlFor={'skill_' + this.props.skill.id}><span className="flag flag--sm flag--muted">{this.props.skill.badge_count}</span> {this.props.skill.tag}</label>
                </div>
            );

        }
    });


    oThis.BadgeCollectionSkill = createReactClass({
        componentDidMount: function() {
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
        },

        componentDidUpdate: function() {
        },


        render: function() {
            var oComponent = this;
            return (
                <span className="flag flag--badged">{this.props.skill}</span>
            );

        }
    });


    //Set
    oThis.BadgeCollectionItem = createReactClass({
        componentDidMount: function() {
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
            $('[data-popover="tooltip"]',$component).tooltip();
        },

        componentDidUpdate: function() {
        },

        handleFlip: function(){
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
            $component.toggleClass("is-flipped");
        },

        handleViewClick: function(event) {
            var oComponent = this;
            event.preventDefault();
            // Deprecated Modal
            // We currently just navigate to view url
            httpGet(this.props.item.view_url).then(
                function(value) {
                    var response = value;
                    var $modal = buildModal(response,{
                        classes: 'modal modal--full',
                        header: "View Badge"
                    });
                    $('body').append($modal);
                    $modal.on("modal:close",function(){
                        $modal.off("modal:close").remove();
                        oThis.Actions.fetchBadges();
                    })
                    $modal.openModal();
                })
            .catch(
                function(reason) {
                    console.error('Error loading badges view.', reason);
                    alertify.error('Unable to Open Badge')
                });

        },

        handleEditClick: function(event) {
            event.preventDefault();
            //Build Modal
            httpGet(this.props.item.edit_url).then(
                function(value) {
                    var response = value;
                    var $modal = buildModal(response,{
                        classes: 'modal modal--full',
                        header: "Edit Awarded Badge"
                    });
                    $('body').append($modal);
                    $modal.on("modal:close",$modal,function(){
                        $modal.off("modal:close").remove();
                        oThis.Actions.fetchBadges();
                    })
                    $modal.openModal({ closeOnEsc: false });
                })
            .catch(
                function(reason) {
                    console.error('Error loading badges edit.', reason);
                    alertify.error('Unable to Open Badge Manager')
                });
        },

        render: function() {
            var oComponent = this;

            var skills = [];
            for(var i = 0; i < this.props.item.skills.length; i++){
                var skill = this.props.item.skills[i];
                skills.push(<oThis.BadgeCollectionSkill skill={skill} key={"key_"+i} />);
            }

            var badgeDescription = this.props.item.description;
            if(badgeDescription.length == 0) {
                badgeDescription = "Badge has no description."
            }

            return (
                <figure className="badge" data-badge-id={this.props.item.id}>

                    <div className="badge-face badge-front">
                        <figcaption className="badge-name">{this.props.item.title}</figcaption>
                        <button className="badge-flip" title="See Details" onClick={this.handleFlip}><i className="icon-rotate-left"></i></button>
                        <a href={this.props.item.view_url}><img className="badge-art" src={this.props.item.image} title={this.props.item.title} /></a>
                        <p className="badge-flags">
                            {(function(){
                                if (oThis.bCanManage) {
                                    return (
                                        <a href={oComponent.props.item.edit_url} onClick={oComponent.handleEditClick} className="button button--sm button--skinny button--pill button--success"><i className="icon-toggle-on"></i> Manage</a>
                                    );
                                }
                            })()}
                            {(function(){
                                if (oComponent.props.item.public) {
                                    return (
                                        <span className="badge-flag" data-popover="tooltip" data-original-title="Is Public"><i className="icon-eye"></i></span>
                                    );
                                } else {
                                    return (
                                        <span className="badge-flag" data-popover="tooltip" data-original-title="Is Private"><i className="icon-eye-slash"></i></span>
                                    );
                                }
                            })()}
                            {(function(){
                                if (oComponent.props.item.linked_evidence_count[0] > 0) {
                                    return (
                                        <span className="badge-flag" data-popover="tooltip" data-original-title="Total Linked Evidence">
                                            <i className="icon-check-circle-o icon--success"></i> {oComponent.props.item.linked_evidence_count[0]}
                                        </span>
                                    );
                                } else {
                                    return (
                                        <span className="badge-flag" data-popover="tooltip" data-original-title="No Linked Evidence">
                                            <i className="icon-check-circle-o icon--warning"></i> 0
                                        </span>
                                    );
                                }
                            })()}
                            {(function(){
                                if (oComponent.props.item.linked_evidence_count[1] > 0) {
                                    return (
                                        <span className="badge-flag" data-popover="tooltip" data-original-title="Accessible Evidence">
                                            <i className="icon-eye"></i> {oComponent.props.item.linked_evidence_count[1]}
                                        </span>
                                    );
                                } else if (oComponent.props.item.linked_evidence_count[0] > 0) {
                                    return (
                                        <span className="badge-flag" data-popover="tooltip" data-original-title="No Accessible Evidence">
                                            <i className="icon-eye-slash"></i>
                                        </span>
                                    );
                                }
                            })()}
                            {(function(){
                                if (oComponent.props.item.issuer_verified) {
                                    return (
                                        <img src={mantl.static_url + "assets/images/icon-verified-org.svg" } className="flag--verification" alt="Verified" data-popover="tooltip" data-original-title="Issuing Organization Verified" />
                                    );
                                } else {
                                    return (
                                        <img src={mantl.static_url + "assets/images/icon-unverified-org.svg" } className="flag--verification" alt="Unverified" data-popover="tooltip" data-original-title="Issuing Organization Not Verified" />
                                    );
                                }
                            })()}

                        </p>
                    </div>
                    <div className="badge-face badge-back">
                        <button className="badge-flip" title="Hide Details" onClick={this.handleFlip}><i className="icon-rotate-right"></i></button>
                        <div className="badge-back-content">
                            {(function(){
                                if (oComponent.props.item.issuer_verified) {
                                    return (
                                        <h5 className="text--center"><small>Issued By</small><br />{oComponent.props.item.issuer} <img src={mantl.static_url + "assets/images/icon-verified-org.svg" } className="flag--verification" alt="Verified" data-popover="tooltip" data-placement="top" title="Verified Organization" /></h5>
                                    );
                                } else {
                                    return (
                                        <h5 className="text--center"><small>Issued By</small><br />{oComponent.props.item.issuer} <img src={mantl.static_url + "assets/images/icon-unverified-org.svg" } className="flag--verification" alt="Unverified" data-popover="tooltip" data-placement="top" title="Unverified Organization" /></h5>
                                    );
                                }
                            })()}

                            <p className="badge-description">{badgeDescription}</p>
                            <div className="badge-skills">{skills}</div>
                            <p><a href={this.props.item.view_url} className="button button--sm button--pill">Full Details</a></p>
                        </div>
                    </div>

                </figure>
            );

        }
    });


};

BadgeCollection.prototype.renderCollection = function(containerID) {
    this.containerID = containerID;
    ReactDOM.render(<this.BadgeCollection />, document.getElementById(this.containerID));
}

//REFLUX STORE
BadgeCollection.prototype.createStore = function() {
    var oThis = this;

    oThis.WorkStore = Reflux.createStore({
        listenables: oThis.Actions,
        badges: {}, //badges store

        init: function() {
        },

        getInitialState: function() {
            this.onFetchBadges();
        },

        onFetchBadges: function() {
            var oStore = this;
            var endpoint;
            if(oThis.fullset){
                endpoint = buildRoute(mantlroutes.portfolio_badges,{ portfolioid: oThis.settings.portfolioid });
            } else if(oThis.noncurated){
                endpoint = buildRoute(mantlroutes.portfolio_noncurated_badges,{ portfolioid: oThis.settings.portfolioid });
            } else {
                endpoint = buildRoute(mantlroutes.portfolio_collection_badges,{ portfolioid: oThis.settings.portfolioid, collectionid: oThis.settings.collectionid });
            }
            if(oThis.settings.params != null){
                endpoint += formatParams(oThis.settings.params);
            }
            httpGet(endpoint).then(
                function(value) {
                    oStore.badges.items = JSON.parse(value);
                    oStore.trigger(oStore.badges);
                })
            .catch(
                function(reason) {
                    console.error('Error loading badge items.', reason);
                    alertify.error('Unable to load badge items.')
                });
        }
    });

    if(oThis.settings.filtercontrols) {
        oThis.SkillsStore = Reflux.createStore({
            listenables: oThis.Actions,
            skills: {}, //store

            init: function() {
            },

            getInitialState: function() {
                this.onFetchSkills();
            },

            onFetchSkills: function() {
                var oStore = this;
                var endpoint;
                if(oThis.fullset){
                    endpoint = buildRoute(mantlroutes.portfolio_skills,{ portfolioid: oThis.settings.portfolioid });
                } else if(oThis.noncurated){
                    endpoint = buildRoute(mantlroutes.portfolio_noncurated_skills,{ portfolioid: oThis.settings.portfolioid });
                } else {
                    endpoint = buildRoute(mantlroutes.portfolio_collection_skills,{ portfolioid: oThis.settings.portfolioid, collectionid: oThis.settings.collectionid });
                }

                httpGet(endpoint).then(
                    function(value) {
                        oStore.skills.items = JSON.parse(value);
                        oStore.trigger(oStore.skills);
                    })
                .catch(
                    function(reason) {
                        console.error('Error loading collection skills.', reason);
                        alertify.error('Unable to load collection skills list.')
                    });
            }

        });
    }

}
